import React, { useState, useContext } from 'react'

import StoreContext from '../storage/context';
import NavigationBar from '../navigationBar/index.js'
import IntegrationLayerSystem from '../integrationLayerSystem/index.js'

import './styles.css'

const IntegrationLayerRegisterSystem = () => {
    const { pk_user, givenName, pk_service } = useContext(StoreContext);

    const navegation = [
        {
            'nome': 'home',
            'link': '/'
        },
        {
            'nome': 'integration layer',
            'link': `/integration-layer?service_id=${pk_service}`
        },
        {
            'nome': 'cadastrar sistema',
            'link': `/integration-layer/sistema/cadastrar`
        }
    ]

    return (
        <div className="ilr-register-container">

            {/* BARRA DE NAVEGAÇÃO */}
            <NavigationBar navegation={navegation} />

            <IntegrationLayerSystem />
        </div> 
    );
}

export default IntegrationLayerRegisterSystem;